export default {
  AddTPrepSubjectModule (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("addTPrepSubjectModule", payload)
      resolve()
    })
  }
}
